import {
  BulkChangeDatesPanel,
  ResponsiveContainer,
  useFormEvents,
  usePageTitle,
  useObservable,
} from '@lib/common';
import { FormStatus, ReservationForms, bulkAvailableRateQuery } from '@lib/state';
import React from 'react';
import { useHistory } from 'react-router-dom';

const targetUrl: string = '/profile/stays';

export const BulkReservationsChangeDatesPage: React.FC = () => {
  usePageTitle('Bulk Reservation Change Dates');
  const history = useHistory();

  const [result] = useFormEvents(ReservationForms.BulkReservationsModify);

  const {
    propertyId,
    corporateAccountId,
    selectedReservations,
    checkInDate,
    checkOutDate,
  } = useObservable(bulkAvailableRateQuery.filters);

  if (
    result.status === FormStatus.Success ||
    propertyId === '' ||
    corporateAccountId === '' ||
    selectedReservations.length === 0
  ) {
    history.push(targetUrl);
  }

  if (!propertyId || !corporateAccountId) return null;

  return (
      <ResponsiveContainer>
        <BulkChangeDatesPanel
          propertyId={propertyId}
          corporateAccountId={corporateAccountId}
          selectedReservations={selectedReservations}
          formEvents={result}
          checkInDate={checkInDate}
          checkOutDate={checkOutDate}
        />
      </ResponsiveContainer>
  );
};
